export const supportedCurrencies = [
  {
    code: 'AED',
    label: 'AED — UAE Dirham',
  },
  {
    code: 'AUD',
    label: 'AUD — Australian Dollar',
  },
  {
    code: 'BRL',
    label: 'BRL — Brazilian Real',
  },
  {
    code: 'CAD',
    label: 'CAD — Canadian Dollar',
  },
  {
    code: 'CHF',
    label: 'CHF — Swiss Franc',
  },
  {
    code: 'CNY',
    label: 'CNY — Chinese Yuan',
  },
  {
    code: 'CZK',
    label: 'CZK — Czech Koruna',
  },
  {
    code: 'DKK',
    label: 'DKK — Danish Krone',
  },
  {
    code: 'EUR',
    label: 'EUR — Euro',
  },
  {
    code: 'GBP',
    label: 'GBP — British Pound',
  },
  {
    code: 'HKD',
    label: 'HKD — Hong Kong Dollar',
  },
  {
    code: 'HUF',
    label: 'HUF — Hungarian Forint',
  },
  {
    code: 'ILS',
    label: 'ILS — Israeli New Shekel',
  },
  {
    code: 'INR',
    label: 'INR — Indian Rupee',
  },
  {
    code: 'JPY',
    label: 'JPY — Japanese Yen',
  },
  {
    code: 'MXN',
    label: 'MXN — Mexican Peso',
  },
  {
    code: 'NOK',
    label: 'NOK — Norwegian Krone',
  },
  {
    code: 'NZD',
    label: 'NZD — New Zealand Dollar',
  },
  {
    code: 'PLN',
    label: 'PLN — Polish Zloty',
  },
  {
    code: 'SAR',
    label: 'SAR — Saudi Riyal',
  },
  {
    code: 'SEK',
    label: 'SEK — Swedish Krona',
  },
  {
    code: 'SGD',
    label: 'SGD — Singapore Dollar',
  },
  {
    code: 'TRY',
    label: 'TRY — Turkish Lira',
  },
  {
    code: 'USD',
    label: 'USD — US Dollar',
  },
  {
    code: 'ZAR',
    label: 'ZAR — South African Rand',
  },
];